import React, { useLayoutEffect, useRef, useState } from 'react';
import Image from 'next/image';

function isReactFragment(variableToInspect) {
  if (!variableToInspect) {
    return;
  }
  if (variableToInspect.type) {
    return variableToInspect.type === React.Fragment;
  }
  return variableToInspect === React.Fragment;
}

export const OfficialDocumentContainer = ({ image, children }) => {
  const targetRef = useRef();
  const [sizes, setSizes] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (targetRef.current) {
      setSizes({ width: targetRef.current.offsetWidth, height: targetRef.current.offsetHeight });
    }
  }, []);

  console.log(children);

  const childrenWithProps = React.Children.map(children, child => {
    if (isReactFragment(child)) {
      return React.Children.map(child.props.children, child => {
        return React.cloneElement(child, { sizes });
      });
    }
    else if (React.isValidElement(child)) {
      return React.cloneElement(child, { sizes });
    }
    return child;
  });

  return (
    <div ref={targetRef} style={{ position: 'relative', marginTop: 15 }}>
      <Image alt="Tax Return" src={image} style={{ width: '100%', height: 'auto' }} />
      {childrenWithProps}
    </div>
  );
};
